import React, { CSSProperties } from 'react';

// eslint-disable-next-line import/no-named-default
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { selectUserData } from 'redux/editProfile/userProfile.slices';
import { useAppSelector } from 'redux/hooks';
import useAuthentication from 'application/authentication/useAuthentication';
import LoadingUserAvatar from 'components/LoadingUserAvatar/LoadingUserAvatar';
import i18n from 'translations/i18n';

import './UserHeaderSection.scoped.scss';
import 'components/Modal/Modal.scoped.scss';

interface Props {
  children?: React.ReactNode;
  boxStyle?: CSSProperties;
}

const UserHeaderSection: React.FC<Props> = () => {
  const { logOut } = useAuthentication();
  const history = useHistory();
  const userData = useAppSelector(selectUserData);
  const { t } = useTranslation('common');
  const lang = i18n.language;

  return (
    <div className="avatar-container">
      <div className="user-img">
        <LoadingUserAvatar height={40} width={40} />
      </div>
      <div className="user-content">
        <div className="title">
          <h4>
            {userData?.first_name} {userData?.last_name}
          </h4>
        </div>
        <div className="settings">
          <p onClick={() => history.push('/edit-profile')}>{t('settings')}</p>
          <p className="v-line"> | </p>
          <p onClick={() => logOut()}>{t('logout')}</p>
        </div>
      </div>

      <div className="user-role">
        <div className={`role-asset ${lang}`}>
          {lang === 'en' && <p>{userData?.role === 'student' ? 'Student' : 'Teacher'}</p>}
          {lang === 'de' && <p>{userData?.role === 'student' ? 'Studierende' : 'Dozent'}</p>}
          {lang === 'ee' && <p>{userData?.role === 'student' ? 'Õpilane' : 'Õpetaja'}</p>}
        </div>
      </div>
    </div>
  );
};

export default UserHeaderSection;
